import React from 'react'

const SecondChild = () => {
  return (
    <div>
      second child
    </div>
  )
}

export default SecondChild
